import React from 'react';
import { Row, Col } from 'antd';
import Link from 'next/link';
import parseCategoryUrl from 'lib/parseCategoryUrl';
import { Title, Text, Category } from 'components/Card';
import VideoImage from 'components/VideoImage';

interface Props {
    $video: Video;
}
const VideoItem = ({
    $video: { seoSlug, openingImage, category, title, description }
}: Props): React.JSX.Element => (
    <Row gutter={16}>
        <Col span={8}>
            <Link href={`/wideo/${seoSlug}`}>
                <VideoImage height={153} width={272} image={openingImage} />
            </Link>
        </Col>
        <Col span={16}>
            {category && (
                <Category>
                    <Link href={parseCategoryUrl(category)}>{category.title}</Link>
                </Category>
            )}
            <Title>
                <Link href={`/wideo/${seoSlug}`}>{title}</Link>
            </Title>
            {description && (
                <Text>
                    <Link href={`/wideo/${seoSlug}`}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: description
                            }}
                        />
                    </Link>
                </Text>
            )}
        </Col>
    </Row>
);

export default VideoItem;
